<template>
	<div class="reportMain">
		<div style="float:right;margin-right:20px;">
			<el-form :inline="true" class="demo-form-inline">
				<el-form-item>
					<el-input placeholder="请输入昵称或账号" v-model="account" style=" margin-top: 4px;">
						<el-button slot="append" icon="el-icon-search" @click="getAttendanceReport"></el-button>
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-date-picker
						:clearable="false"
						v-model="datatime"
						type="daterange"
						:picker-options="pickerOptions"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						value-format="yyyy-MM-dd"
						@change="getAttendanceReport"
					></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-select placeholder="客服" v-model="selectVal" @change="getAttendanceReport">
						<el-option v-for="item in userList" :key="item.id" :label="item.nickName" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button
						type="primary"
						@click="exportExcel"
						:loading="exportLoading"
					>{{exportLoading?'正在处理...':'导出数据'}}</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div>
			<el-table
				:data="attenList.slice((currentPage-1)*pagesize,currentPage*pagesize)"
				v-loading="tableLoading"
			>
				<el-table-column prop="time" label="时间" width="100px"></el-table-column>
				<el-table-column prop="nickName" label="昵称" width="100px"></el-table-column>
				<el-table-column prop="account" label="账号" width="100px"></el-table-column>
				<el-table-column label="首次在线时间" width="100px">
					<template slot-scope="scope">{{getFormatTime(scope.row.firstOnlineTime)}}</template>
				</el-table-column>
				<el-table-column label="最后在线时间" width="100px">
					<template slot-scope="scope">{{getFormatTime(scope.row.lastOnlineTime)}}</template>
				</el-table-column>
				<el-table-column label="在线时长" width="100px">
					<template slot-scope="scope">{{secondToDate(scope.row.loginTime)}}</template>
				</el-table-column>
				<el-table-column label="会话总时长">
					<template slot-scope="scope">{{secondToDate(scope.row.sumSessionDuration)}}</template>
				</el-table-column>
				<!-- <el-table-column label="首次就绪时间" width="100px">
					<template slot-scope="scope">{{getFormatTime(scope.row.firstMoveInTime)}}</template>
				</el-table-column>-->
				<el-table-column label="就绪时长" width="100px">
					<template slot-scope="scope">{{secondToDate(scope.row.moveInTime)}}</template>
				</el-table-column>
				<el-table-column prop="moveInCount" label="就绪次数">
					<template slot-scope="scope">{{getVal(scope.row.moveInCount)}}</template>
				</el-table-column>
				<el-table-column label="未就绪时长" width="100px">
					<template slot-scope="scope">{{secondToDate(scope.row.moveOutTime)}}</template>
				</el-table-column>
				<el-table-column prop="moveOutCount" label="未就绪次数">
					<template slot-scope="scope">{{getVal(scope.row.moveOutCount)}}</template>
				</el-table-column>
				<el-table-column label="小休时长" width="100px">
					<template slot-scope="scope">{{secondToDate(scope.row.restTime)}}</template>
				</el-table-column>
				<el-table-column prop="restCount" label="小休次数">
					<template slot-scope="scope">{{getVal(scope.row.restCount)}}</template>
				</el-table-column>
				<el-table-column label="培训时长" width="100px">
					<template slot-scope="scope">{{secondToDate(scope.row.cultivateTime)}}</template>
				</el-table-column>
				<el-table-column prop="cultivateCount" label="培训次数">
					<template slot-scope="scope">{{getVal(scope.row.cultivateCount)}}</template>
				</el-table-column>
				<el-table-column label="用餐时长">
					<template slot-scope="scope">{{secondToDate(scope.row.haveMealsTime)}}</template>
				</el-table-column>
				<el-table-column prop="haveMealsCount" label="用餐次数">
					<template slot-scope="scope">{{getVal(scope.row.haveMealsCount)}}</template>
				</el-table-column>
				<el-table-column label="挂起时长" width="100px">
					<template slot-scope="scope">{{secondToDate(scope.row.hangUpTime)}}</template>
				</el-table-column>
				<el-table-column prop="moveOutCount" label="挂起次数">
					<template slot-scope="scope">{{getVal(scope.row.hangUpCount)}}</template>
				</el-table-column>
				<el-table-column label="在线时长比">
					<template slot-scope="scope">{{getRatio(scope.row.loginTimeRatio)}}</template>
				</el-table-column>
				<el-table-column label="就绪率">
					<template slot-scope="scope">{{getRatio(scope.row.moveInRatio)}}</template>
				</el-table-column>
				<el-table-column label="未就绪率">
					<template slot-scope="scope">{{getRatio(scope.row.moveInRatio)}}</template>
				</el-table-column>
				<el-table-column label="小休率">
					<template slot-scope="scope">{{getRatio(scope.row.restRatio)}}</template>
				</el-table-column>
				<el-table-column label="培训率">
					<template slot-scope="scope">{{getRatio(scope.row.cultivateRatio)}}</template>
				</el-table-column>
				<el-table-column label="用餐率">
					<template slot-scope="scope">{{getRatio(scope.row.haveMealsRatio)}}</template>
				</el-table-column>
				<el-table-column label="挂起率">
					<template slot-scope="scope">{{getRatio(scope.row.hangUpRatio)}}</template>
				</el-table-column>
				<!-- 
				<el-table-column label="最后挂起时间">
					<template slot-scope="scope">{{getFormatTime(scope.row.maxHangUpTime)}}</template>
				</el-table-column>
				<el-table-column label="登出时间">
					<template slot-scope="scope">{{getFormatTime(scope.row.logoutTime)}}</template>
				</el-table-column>-->
			</el-table>
			<div class="pagination">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[10, 20, 30]"
					background
					:page-size="pagesize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="parseInt(total)"
				></el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
import { DateTime } from '@/utils/common'
import { FormatTimes, formatDuring } from '@/utils/FormatTime'

export default {
	name: 'attendanceReport',
	props: [],
	data() {
		return {
			datatime: [],
			pickerOptions: {
				disabledDate(date) {
					return date.getTime() >= Date.now()
				},
				shortcuts: [
					{
						text: '最近一周',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 7
							)
							picker.$emit('pick', [start, end])
						}
					},
					{
						text: '最近一个月',
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(
								start.getTime() - 3600 * 1000 * 24 * 30
							)
							picker.$emit('pick', [start, end])
						}
					}
				]
			},
			userList: [],
			attenList: [],
			selectVal: 0,
			account: '',
			pagesize: 10,
			currentPage: 1,
			total: 0,
			tableLoading: false,
			exportLoading: false
		}
	},
	mounted: function() {},
	created: function() {
		let time = new DateTime()
		this.datatime.push(time.getYesterday())
		this.datatime.push(time.getYesterday())

		this.getUser()
		this.getAttendanceReport()
	},
	watch: {},
	methods: {
		getAttendanceReport() {
			let vm = this
			let userId = []
			if (vm.selectVal > 0) {
				userId.push(vm.selectVal)
			}
			vm.tableLoading = true
			this.axios
				.post('HistoryReportForm/GetAttendanceReports', {
					UserId: userId,
					StartTime: vm.datatime[0],
					endTime: vm.datatime[1],
					realName: vm.account
				})
				.then(function({ data }) {
					if (data.result) {
						vm.attenList = data.data
						vm.total = data.data.length
					} else {
						vm.$message({ type: 'error', message: data.message })
					}
					vm.tableLoading = false
				})
		},
		getUser() {
			var $this = this

			$this.option3 = []
			this.axios
				.get('User/Select', {
					headers: {
						'Content-Type': 'application/json'
					}
				})
				.then(function({ data }) {
					// $this.option3 = data.data;
					var ss1 = {
						id: 0,
						nickName: '全部'
					}
					data.push(ss1)
					$this.userList = data
				})
		},
		secondToDate(msg) {
			if (msg == undefined || msg == null || msg == 0) {
				return '--'
			}
			return formatDuring(msg)
		},
		getFormatTime(val) {
			if (val == undefined || val == null || val == 0) {
				return '--'
			}
			return FormatTimes(val, 'hh:mm:ss')
		},
		getRatio(val) {
			if (val == undefined || val == null || val == 0) {
				return '--'
			}
			return val + '%'
		},
		getVal(val) {
			if (val == 0) {
				return '--'
			}
			return val
		},
		handleSizeChange(val) {
			this.pagesize = val
		},
		handleCurrentChange(val) {
			this.currentPage = val
		},
		exportExcel() {
			let vm = this
			vm.exportLoading = true
			let userId = []
			if (vm.selectVal > 0) {
				userId.push(vm.selectVal)
			}
			this.axios
				.post(
					'HistoryReportForm/ExportAttendanceReports',
					{
						UserId: userId,
						StartTime: vm.datatime[0],
						endTime: vm.datatime[1],
						realName: vm.account
					},
					{
						responseType: 'blob'
					}
				)
				.then(function(res) {
					let filename = `考勤报表${vm.datatime[0]}_${vm.datatime[1]}.xls`
					let blob = res.data
					let reader = new FileReader()
					reader.readAsDataURL(blob)
					reader.onload = e => {
						//创建a标签，插入到文档中并click，最后移除
						let a = document.createElement('a')
						a.download = filename
						a.href = e.target.result
						document.body.appendChild(a)
						a.click()
						document.body.removeChild(a)
						vm.exportLoading = false
						vm.$message({ type: 'success', message: '导出成功' })
					}
				})
		}
	}
}
</script>
<style scoped>
.reportMain {
	width: 100%;
	padding-bottom: 30px;
	padding-right: 15px;
}
.pagination {
	float: right;
	margin-top: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/manage/reportForm/attendanceReport.vue